import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { RouteType } from "../@types/RouteType";
import { FC, useEffect, useState } from "react";
import { checkMatchedRoute } from "../utils/checkMatchedRoute";

interface RequireDealerPermissionsProps {
    route: RouteType
}

const RequireDealerPermission: FC<RequireDealerPermissionsProps> = ({ route }) => {

    const [routeAuthorized, setRouteAuthorized] = useState<boolean>(true);

    const { user, userAuthorizedRoutes } = useAuth();

    const { id } = useParams();

    const location = useLocation();

    useEffect(() => {

        if (user && userAuthorizedRoutes.length) {

            const dynamicRoute: boolean = id !== undefined;

            const authorizedRoute: boolean = checkMatchedRoute(userAuthorizedRoutes, location, dynamicRoute);

            setRouteAuthorized(authorizedRoute);

            if (!authorizedRoute) {

                console.log(`Authorized Route: ${authorizedRoute}`);

            }

        }
        
    }, [
        id,
        location,
        user,
        userAuthorizedRoutes,
        setRouteAuthorized
    ]);

    return (
        routeAuthorized
            ? <Outlet />
            : <Navigate to="/404" />
    )
}

export default RequireDealerPermission;